:host {
  display: block;
}

.cta-added-to-cart-label {
  display: block;
}

.cta-added-to-cart-label__content {
  display: flex;
  justify-content: center;
  align-items: center;
  color: #000000;
  font-size: 0.8125rem;
  line-height: 1.125rem;
  height: 1.125rem;
  letter-spacing: -0.005rem;
  margin: 10px auto 0;
  overflow: hidden;
}

:host(:not([dir="rtl"])) .cta-added-to-cart-label__icon {
  padding-right: 2px;
}

:host([dir="rtl"]) .cta-added-to-cart-label__icon {
  padding-left: 2px;
}